module.exports = __webpack_public_path__ + "img/slider2.17b8a8e1.jpg";